module.exports = __webpack_public_path__ + "img/ig-logo.9fd51bd5.png";